import {ShareLandLogoLink} from '#/components/header/share-land-logo-link';
import {HeaderContentLayout} from '#/components/layout/layout';
import {WalletContext} from '#/contexts/wallet-provider';
import {useSwitchToTargetChain} from '#/hooks/wagmi/use-switch-to-target-chain';
import {Page} from '#/pages/page';
import {DefaultChildren} from '#/utils/utils';
import {WifiIcon} from '@heroicons/react/24/solid';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {useConfig} from 'wagmi';

const SwitchNetworkPage: FunctionComponent<DefaultChildren> = () => {
  const {t} = useTranslation('translation');

  const {
    accountResult: {chain},
  } = useContext(WalletContext);
  const {chains} = useConfig();

  return (
    <Page title={t('pages.switchChain.htmlTitle')}>
      <HeaderContentLayout className='bg-black'>
        <Header />
        <div className='bg-black overflow-y-scroll flex-center p-8'>
          <div className='flex flex-col items-center gap-4 sm:gap-10 '>
            <WifiIcon className='w-16 h-16 fill-deepblue stroke-deepblue' />
            <div className='text-white text-xl sm:text-3xl font-bold text-center'>
              <span className='block'>{t('pages.switchChain.explanation.title')}</span>
              <span className='block'>
                {chain?.name
                  ? t('pages.switchChain.explanation.connectedTo', {
                      chainName: chain.name,
                    })
                  : t('pages.switchChain.explanation.connectedToUnknownChain')}
              </span>
              <span className='block'>
                {chains[0]?.name
                  ? t('pages.switchChain.explanation.pleaseConnect', {
                      chainName: chains[0].name,
                    })
                  : t('pages.switchChain.explanation.pleaseConnectUnkownChain')}
              </span>
            </div>
            <SwitchChainButton />
          </div>
        </div>
      </HeaderContentLayout>
    </Page>
  );
};

const SwitchChainButton: FunctionComponent = () => {
  const {t} = useTranslation();

  const switchChain = useSwitchToTargetChain();

  const onClick = () => {
    switchChain();
  };

  return (
    <button
      className='text-base sm:text-xl bg-deepblue p-3 text-white font-bold rounded-xl mt-3 sm:mt-6 hover:opacity-70 transition-opacity'
      onClick={onClick}
    >
      {t('actions.switchChain')}
    </button>
  );
};

const Header: FunctionComponent = () => {
  return (
    <header className={'h-header w-full bg-black px-5 py-3'}>
      <div className='w-full h-full flex justify-between items-center gap-4 mx-auto'>
        <div className='grow flex h-full items-center'>
          <div className='w-[24px]' />
          <ShareLandLogoLink />
        </div>
      </div>
    </header>
  );
};

export {SwitchNetworkPage};
